var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Heading, Paragraph } from "@riseart/common";
import { articleHeaderCls, articleHeaderDetailCls } from "./Article.less";
var ArticleHeader = /* @__PURE__ */ __name(function ArticleHeader2(_ref) {
  var title = _ref.title, category = _ref.category, children = _ref.children, details = _ref.details;
  return /* @__PURE__ */ React.createElement("header", {
    className: articleHeaderCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h2",
    level: "4"
  }, category), /* @__PURE__ */ React.createElement(Heading, {
    tag: "h1"
  }, title), children ? /* @__PURE__ */ React.createElement(Paragraph, null, children) : null, /* @__PURE__ */ React.createElement("div", {
    className: articleHeaderDetailCls
  }, details));
}, "ArticleHeader");
export {
  ArticleHeader
};
